<div class="noPrint mobile-bars d-block d-lg-none position-fixed">
  <button (click)="openMobileMenu()" class="noPrint btn btn-primary">
    <i class="fas fa-bars"></i>
  </button>
</div>

<div id="sidebar" class="noPrint left-side-bar d-none d-lg-block">
  <div class="row">
    <div class="col-12 py-4 text-center">
      <img [routerLink]="['/']" routerLinkActive="router-link-active" class="w-75 c-pointer"
           src="/assets/images/m2m.png" />
    </div>
  </div>

  <div class="noPrint row justify-content-end">
    <div class="col-11">

      <div class="text-left my-3 c-pointer outline-none direction-right" *ngFor="let menu of mainMenu; let i = index">
        <div *ngIf="!(menu?.children?.length); else hasChild" [routerLink]="[menu.route, menu.params]"
             class="left-nav-item outline-none d-flex justify-content-between" [routerLinkActive]="['active']">
          <div>
            <i [class]="menu.icon"></i>
            {{menu.name | translate}}
          </div>
        </div>

        <ng-template #hasChild>
          <div #hasChild (click)="changeOpenStatus(menu);"
               class="noPrint left-nav-item outline-none d-flex justify-content-between">
            <div>
              <i [class]="menu.icon"></i>
              {{menu.name | translate}}
            </div>
            <i class="fas fa-angle-down text-white"></i>
          </div>
        </ng-template>

        <div class="noPrint row" *ngIf="menu.isOpen">
          <div class="col-12" *ngFor="let child of menu.children">
            <div class="left-nav-item outline-none pl-5" [routerLink]="[child.route, child.params]"
                 [routerLinkActive]="['active']">
              {{child.name | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


<!--logout-->
  <div class="noPrint row justify-content-end">
    <div *ngIf="isAdmin" class="col-11">
      <div (click)="backToAdmin()" class="left-nav-item  direction-right outline-none c-pointer">
        <i class="fas fa-users-cog"></i>
        {{'navigation.back_to_admin' | translate}}
      </div>
    </div>
    <div class="col-11">
      <div (click)="confirmLogout()" class="left-nav-item  direction-right outline-none c-pointer">
        <i class="fas fa-sign-out-alt"></i>
        {{'navigation.logout' | translate}}
      </div>
    </div>
  </div>

</div>



<!--mobile menu-->
<div class="noPrint mobile-sidebar left-side-bar d-block d-lg-none" [class.menu-stretch]="isMobile">
  <div class="row">
    <div class="col-3 py-4 text-center my-auto">
      <button (click)="openMobileMenu()" class="btn btn-primary">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="col-9 py-4 text-center">
      <img [routerLink]="['/']" routerLinkActive="router-link-active" style="width: 125px" class="c-pointer"
        src="/assets/images/m2m.png" />
    </div>
  </div>


  <div class="row justify-content-end">
    <div class="col-11">
      <div class="text-left my-3 c-pointer outline-none direction-right" *ngFor="let menu of mainMenu; let i = index">
        <div *ngIf="!(menu?.children?.length); else hasChild" (click)="routerInMobile(menu.route, menu.params)"
          class="left-nav-item outline-none d-flex justify-content-between" [routerLinkActive]="['active']">
          <div>
            <i [class]="menu.icon"></i>
            {{menu.name | translate}}
          </div>
        </div>

        <ng-template #hasChild>
          <div #hasChild (click)="changeOpenStatus(menu);"
            class="left-nav-item outline-none d-flex justify-content-between">
            <div>
              <i [class]="menu.icon"></i>
              {{menu.name | translate}}
            </div>
            <i class="fas fa-angle-down text-white"></i>
          </div>
        </ng-template>

        <div class="row" *ngIf="menu.isOpen">
          <div class="col-12" *ngFor="let child of menu.children">
            <div class="left-nav-item outline-none pl-5" (click)="routerInMobile(child.route, child.params)"
              [routerLinkActive]="['active']">
              {{child.name | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="row justify-content-end">
    <div *ngIf="isAdmin" class="col-11">
      <div (click)="backToAdmin()" class="left-nav-item  direction-right outline-none c-pointer">
        <i class="fas fa-users-cog"></i>
        {{'navigation.back_to_admin' | translate}}
      </div>
    </div>
    <div class="col-11">
      <div (click)="confirmLogout()" class="left-nav-item  direction-right outline-none c-pointer">
        <i class="fas fa-sign-out-alt"></i>
        {{'navigation.logout' | translate}}
      </div>
    </div>
  </div>
</div>
